import apiClient from '@/lib/axios';

type ReportFormat = 'pdf' | 'xlsx';

const PDF_MIME_TYPE = 'application/pdf';
const EXCEL_MIME_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

interface EstimatorReportFilters {
  startDate?: string;
  endDate?: string;
}

/**
 * Downloads an Estimator Account Report in the specified format
 */
export const downloadEstimatorReport = async (
  userId: number,
  format: ReportFormat = 'pdf',
  filters?: EstimatorReportFilters
): Promise<void> => {
  const params = new URLSearchParams();
  params.append('format', format);
  if (filters?.startDate) params.append('startDate', filters.startDate);
  if (filters?.endDate) params.append('endDate', filters.endDate);

  const response = await apiClient.get(
    `/reports/estimator/${userId}?${params.toString()}`,
    { responseType: 'blob' }
  );

  const mimeType = format === 'pdf' ? PDF_MIME_TYPE : EXCEL_MIME_TYPE;
  const extension = format === 'pdf' ? 'pdf' : 'xlsx';

  const blob = new Blob([response.data], { type: mimeType });
  const blobUrl = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = `estimator-report-${new Date().toISOString().split('T')[0]}.${extension}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
};

/**
 * Opens an Estimator Account Report as PDF in a new browser tab
 */
export const openEstimatorReportPdf = async (
  userId: number,
  filters?: EstimatorReportFilters
): Promise<void> => {
  const params = new URLSearchParams();
  params.append('format', 'pdf');
  if (filters?.startDate) params.append('startDate', filters.startDate);
  if (filters?.endDate) params.append('endDate', filters.endDate);

  const response = await apiClient.get(
    `/reports/estimator/${userId}?${params.toString()}`,
    { responseType: 'blob' }
  );

  const blob = new Blob([response.data], { type: PDF_MIME_TYPE });
  const blobUrl = window.URL.createObjectURL(blob);
  window.open(blobUrl, '_blank');

  setTimeout(() => window.URL.revokeObjectURL(blobUrl), 60000);
};
